import styled from "styled-components";

const Privacy = () => {
  return (
    <Container>
      <h3 className="title">개인정보 처리방침</h3>
      <p>
        본 개인정보 처리방침은 "소음방망이"(이하 "앱")에서 제공하는 서비스
        이용과 관련하여 사용자의 개인정보가 어떻게 수집, 사용, 보호되는지에 대해
        설명합니다. 본 방침은 관련 법령 및 규정을 준수하며, 필요에 따라 변경될
        수 있습니다.
      </p>

      <ul>
        <li>
          <strong>1. 수집하는 개인정보 항목</strong>
          <ul>
            <li>
              앱은 원호할 서비스 제공을 위해 다음과 같은 개인정보를 수집할 수
              있습니다.
            </li>
            <li>
              <strong>(1) 필수 수집 정보</strong>
              <ul className="list-desc">
                <li>기기 정보 (OS, 앱 버전, 기기 모델 등)</li>
                <li>이메일 주소 혹은 SNS 계정 정보</li>
                <li>성별, 나이 (가입 시 입력)</li>
              </ul>
            </li>
            <li>
              <strong>(2) 선택적 수집 정보 (사용자가 입력 시 수집)</strong>
              <ul className="list-desc">
                <li>닉니메임 및 프리필 사진</li>
                <li>사용자 유형 검사 결과</li>
                <li>소음 치정 시간별 데시벨 데이터</li>
                <li>커뮤니티 작성 내용 (후기, 댓글 등)</li>
              </ul>
            </li>
          </ul>
        </li>

        <li>
          <strong>2. 개인정보의 수집 및 이용 목적</strong>
          <span>
            앱은 수집한 개인정보를 다음과 같은 목적에 한하여 이용합니다.
          </span>
          <ul className="list-no">
            <li>총시간소음 치정 및 분석 서비스 제공</li>
            <li>사용자의 총시간소음 문제 유형 분석 서비스 제공</li>
            <li>커뮤니티 내 사용자 시각별</li>
            <li>앱 사용성 감사 및 서비스 최적화</li>
            <li>문의사항 응답 및 고객 지원</li>
          </ul>
        </li>

        <li>
          <strong>3. 개인정보 보관 및 파기</strong>
          <span>
            앱은 사용자의 개인정보를 법령에서 정한 기간 동안 보관하며, 보관
            기간이 경과하거나 이용 목적이 달성된 경우 즉시 파기합니다.
          </span>
          <ul className="list-desc">
            <li>계정 정보: 회원 탈퇴 시 즉시 삭제</li>
            <li>
              총시간소음 치정 데이터: 사용자가 직접 삭제 하거나 앱 탈퇴 시 파기
            </li>
            <li>닉니메임 및 프리필 사진: 계정 탈퇴 시 삭제</li>
            <li>커뮤니티 작성 내용: 사용자 삭제 요청 시 즉시 삭제</li>
            <li>
              <strong>
                IP, 브라우저, 단말기 정보 보속: 통신비밀보호법에 따른 3개월간
                보관 후 파기
              </strong>
            </li>
          </ul>
        </li>

        <li>
          <strong>4. 개인정보 제공 및 공용</strong>
          <span>
            앱은 사용자의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다리
            다음과 같은 경우 예외적으로 제공될 수 있습니다.
          </span>
          <ul className="list-desc">
            <li>사용자가 사전에 동의한 경우</li>
            <li>법령에 의해 요청이 있는 경우 (수사기관 요청 등)</li>
            <li>
              서비스 운영을 위한 필수적인 업무 위키의 경우 (예: 데이터 분석
              업체)
            </li>
          </ul>
        </li>

        <li>
          <strong>5. 개인정보 보호를 위한 조치</strong>
          <span>
            앱은 사용자의 개인정보를 보호하기 위해 다음과 같은 조치를 시행하고
            있습니다.
          </span>
          <ul className="list-desc">
            <li>개인정보 암호화 저장 및 전송</li>
            <li>개인정보 접근 제한 및 관리</li>
            <li>보안 소프트웨어를 통해 보호</li>
          </ul>
        </li>

        <li>
          <strong>6. 사용자의 권리 및 행사 방법</strong>
          <span>
            사용자는 언제든지 본인의 개인정보를 열람, 수정, 삭제 요청할 수
            있습니다.
          </span>
          <ul className="list-desc">
            <li>개인정보 수정 및 삭제: 앱 설정 메뉴에서 가능</li>
            <li>계정 탈퇴: 설정 &gt 계정 삭제 메뉴 이용</li>
            <li>문의 사항: 고객지원 이메일 문의</li>
          </ul>
        </li>

        <li>
          <strong>7. 만 14세 미만 아동의 개인정보 처리에 관한 사항</strong>
          <ul>
            <li>
              소음방막이는 만 14세 미만 아동에게 서비스를 제공하지 않으며, 이에
              따른 개인정보를 수집하지 않습니다.
            </li>
            <li>
              만 14세 미만의 사용자가 서비스를 이용하려는 경우, 부모만 또는 법정
              대리인의 동의가 필요합니다.
            </li>
          </ul>
        </li>

        <li>
          <strong>8. 개인정보 보호책임자 및 연락처</strong>
          <span>
            개인정보 보호와 관련된 문의 사항은 아래의 연락처로 문의해 주세요.
          </span>
          <ul className="list-desc">
            <li>담당자: 이슬</li>
            <li>이메일: warchief@rs101.co.kr</li>
            <li>연락처: 010-2516-1326</li>
          </ul>
        </li>

        <li>
          <strong>9. 변경사항 고지</strong>
          <ul>
            <li>
              본 개인정보 처리법은 변경 시 앱 간 공지사항을 통해 사전 안내드릴
              예정입니다.
            </li>
            <li>최종 업데이트: 2025-03-08</li>
          </ul>
        </li>
      </ul>
    </Container>
  );
};

export default Privacy;

const Container = styled.div`
  padding: 2.5rem;
  overflow: hidden scroll;
  height: 100%;
  h3 {
    font-size: 2rem;
    line-height: 2.4rem;
  }
  p {
    font-size: 1.2rem;
    line-height: 1.4rem;
    padding: 2rem 0 1rem;
  }
  ul {
    padding: 2rem 0;
    display: flex;
    flex-direction: column;
    gap: 3rem;
    > li {
      display: flex;
      flex-direction: column;
      gap: 1.2rem;
      line-height: 1.6rem;
      > strong {
        font-size: 1.6rem;
      }
      > span {
        font-size: 1.2rem;
        line-height: 1.4rem;
      }
      ul {
        padding: 0;
        display: flex;
        flex-direction: column;
        gap: 1.2rem;
        li {
          font-size: 1.2rem;
          display: flex;
          flex-direction: column;
          gap: 0.8rem;
          strong {
            font-size: 1.4rem;
          }
          ul {
            display: block;
            li {
              display: block;
            }
          }
        }
        &.list-desc {
          counter-reset: item;
          display: flex;
          flex-direction: column;
          gap: 0.4rem;
          li {
            position: relative;
            padding-left: 1.4rem;
            counter-increment: item;
            strong {
              font-size: 1.2rem;
            }
            &::before {
              content: "";
              width: 4px;
              height: 4px;
              border-radius: 50%;
              background-color: black;
              top: 50%;
              transform: translateY(-50%);
              position: absolute;
              left: 0.5rem;
              color: #555;
            }
            ul {
              padding: 0.6rem 0;
              li {
              }
              &.list-alphabat {
                counter-reset: alphab;
                li {
                  position: relative;
                  padding-left: 1.4rem;
                  counter-increment: alphab;
                  &::before {
                    content: counter(alphab, lower-alpha) ". ";
                    position: absolute;
                    left: 0;
                    color: #555;
                  }
                }
              }
            }
          }
        }
        &.list-no {
          counter-reset: item;
          display: flex;
          flex-direction: column;
          gap: 0.4rem;
          li {
            position: relative;
            padding-left: 1.4rem;
            counter-increment: item;
            &::before {
              content: counter(item) ". ";
              position: absolute;
              left: 0;
              color: #555;
            }
            ul {
              padding: 0.6rem 0;
              li {
              }
              &.list-alphabat {
                counter-reset: alphab;
                li {
                  position: relative;
                  padding-left: 1.4rem;
                  counter-increment: alphab;
                  &::before {
                    content: counter(alphab, lower-alpha) ". ";
                    position: absolute;
                    left: 0;
                    color: #555;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
